import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d2ee765e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "questionnaire__alternatives" }
const _hoisted_2 = ["onClick", "for"]
const _hoisted_3 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIViewer = _resolveComponent("TUIViewer")!

  return (_openBlock(), _createElementBlock("ul", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alternatives, (alternative) => {
      return (_openBlock(), _createElementBlock("li", {
        key: `alternative-${alternative.id}`
      }, [
        _createElementVNode("label", {
          onClick: ($event: any) => (_ctx.onSelectAlternative(alternative)),
          class: _normalizeClass(
                ['questionnaire__alternative',
                {disabled: (!_ctx.isAbleToRedoQuestions && _ctx.question.status.attempts > 0) || _ctx.question.attemptLimit !== null && _ctx.question.status.attempts === _ctx.question.attemptLimit},
                {correct: (_ctx.question.status.isCorrect === true &&
                _ctx.question.status.alternativeAnsweredID === alternative.id) ||
                _ctx.question.status.correctAlternativeID === alternative.id},
                {incorrect: _ctx.question.status.isCorrect === false &&
                _ctx.question.status.correctAlternativeID !== null &&
                _ctx.question.status.alternativeAnsweredID === alternative.id
                }
                ]),
          for: alternative.id
        }, [
          _createElementVNode("span", {
            class: _normalizeClass(
              ['input-icon',
              { selected:
              _ctx.question.status.alternativeAnsweredID === alternative.id &&
              (_ctx.question.status.isCorrect !== false || _ctx.question.status.attempts === _ctx.question.attemptLimit)
              }
              ])
          }, null, 2),
          _createVNode(_component_TUIViewer, {
            "model-value": alternative.description
          }, null, 8, ["model-value"])
        ], 10, _hoisted_2),
        _createElementVNode("input", {
          id: alternative.id,
          type: "radio",
          name: "alternative",
          hidden: ""
        }, null, 8, _hoisted_3)
      ]))
    }), 128))
  ]))
}